import { render, staticRenderFns } from "./tentative-sales-input.vue?vue&type=template&id=23dfdf2a&"
import script from "./tentative-sales-input.vue?vue&type=script&lang=js&"
export * from "./tentative-sales-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports